import {Component, inject, LOCALE_ID, OnDestroy, OnInit, Signal} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';
import {createApplication, setApplication, updateApplication} from '../../../../store/actions/application.actions';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ServiceAppEntityServiceRead
} from '../../../../openapi';
import {selectApplication, selectLoading, selectPending} from '../../../../store/selectors/application.selectors';
import {selectServiceByUrl, selectUISettings} from '../../../../store/selectors/app.selectors';
import {getLocaleMonthNames, TranslationWidth} from '@angular/common';
import {Subscription} from 'rxjs';
import {toObservable} from '@angular/core/rxjs-interop';
import {UISettings} from "../../../../services/ssession.service";

// only for sections (steeps)
@Component({
  selector: 'app-application-common',
  template: '',
  standalone: true
})
export class ApplicationCommonComponent implements OnInit, OnDestroy {

  public router: Router = inject(Router);
  public route: ActivatedRoute = inject(ActivatedRoute);
  public store$: Store = inject(Store);

  public uiSettings: Signal<UISettings | null> = this.store$.selectSignal(selectUISettings);

  private fetchUiSettings: Subscription = toObservable(this.uiSettings).subscribe(s => this.onFetchUiSettings(s));

  public onFetchUiSettings(settings: UISettings | null): void {
  }

  private locale = inject(LOCALE_ID);

  public monthList = getLocaleMonthNames(this.locale, 1, TranslationWidth.Wide);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  // getting content url from root route data
  public serviceType: Signal<ServiceAppEntityServiceRead | null> = this.store$.selectSignal(selectServiceByUrl(this.route.parent?.snapshot?.data['contentUrl'] || ''));

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
  };

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => this.onFetchApplicationData(app));

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  // only for first steep
  public createApplication(
    redirectPath: string,
    formValue: ApplicationAppEntityApplicationWrite,
    successFnc?: (application: ApplicationAppEntityApplicationRead) => void
  ): void {
    this.store$.dispatch(createApplication({
      serviceTypeId: this.serviceType()?.uuid || '',
      application: formValue,
      successFnc: successFnc || ((application) => {
        this.router.navigate(
          ['../', application?.uuid, redirectPath],
          {
            relativeTo: this.route
          }
        );
      }),
      failureFnc: () => {
      }
    }));
  }

  public updateApplication(
    redirectPath: string,
    formValue: ApplicationAppEntityApplicationWrite,
    successFnc?: (application: ApplicationAppEntityApplicationRead) => void
  ): void {
    this.store$.dispatch(updateApplication({
      id: this.applicationId || '',
      application: formValue,
      successFnc: successFnc || ((application) => {
        this.router.navigate(
          ['../../', application?.uuid, redirectPath],
          {
            relativeTo: this.route
          }
        );
      }),
      failureFnc: () => {
      }
    }));
  }

  // only for first steep
  public onCancel(): void {
    this.router.navigate([this.applicationId ? '../../../' : '../../'], {relativeTo: this.route})
      .then(() => this.store$.dispatch(setApplication({application: null})));
  }


  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
    this.fetchUiSettings.unsubscribe();
  }
}
